module.exports = __webpack_public_path__ + "img/errorImg1.06d8b145.png";